import React from "react";

function off(){
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path d="M12.2358 23C18.311 23 23.2358 18.0751 23.2358 12C23.2358 5.92487 18.311 1 12.2358 1C6.16071 1 1.23584 5.92487 1.23584 12C1.23584 18.0751 6.16071 23 12.2358 23Z" stroke="#BABEC3" stroke-width="1.5"/>
      <path d="M12.2397 7.26212V11.5765" stroke="#BABEC3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M14.8591 7.96933C15.7259 8.52601 16.3883 9.3493 16.7466 10.3152C17.1049 11.2811 17.1396 12.3372 16.8455 13.3245C16.5442 14.3123 15.9337 15.1771 15.1038 15.7917C14.2739 16.4062 13.2685 16.7379 12.2359 16.7379C11.2032 16.7379 10.1978 16.4062 9.36795 15.7917C8.53805 15.1771 7.92749 14.3123 7.62626 13.3245C7.33213 12.3372 7.36682 11.2811 7.7251 10.3152C8.08337 9.3493 8.74582 8.52601 9.61266 7.96933" stroke="#BABEC3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    )
}
export default off;